<template>
  <div class="switer-image">
    <!-- :autoplay="3000" -->
    <van-swipe ref="swipeRef" @change="prepareImages">
      <van-swipe-item v-if="videoUrl">
        <div class="img-box">
          <div @click="handlePlayerClick" v-if="!KVideoPlayerShow">
            <img class="img-content" :src="$cvWebpFn(images[0], { w: 828 })" loading="eager" fetchpriority="high" :alt="imgTitle" @load="onImageLoad(0)">
            <span class="img-content loading-box"><van-icon name="play-circle-o" size="56" color="#fff" /></span>
          </div>
          
          <KVideoPlayer v-else :autoPlay="true" :src="videoUrl" class="img-content" />
        </div>
      </van-swipe-item>
      <van-swipe-item v-for="(image, idx) in images" :key="image">
        <div class="img-box">
          <img v-if="preparedImages.has(idx + (videoUrl ? 1 : 0))" :src="$cvWebpFn(image, { w: 828 })" class="img" loading="eager" :fetchpriority="!videoUrl && idx === 0 ? 'high' : 'low'" :alt="imgTitle" @load="onImageLoad(idx + (videoUrl ? 1 : 0))" />
        </div>
      </van-swipe-item>

      <template #indicator="{ active, total }">
        <div class="custom-indicator">{{ (active || 0) + 1 }}&nbsp;/&nbsp;{{ total }}</div>
      </template>
    </van-swipe>
  </div>
</template>

<script setup lang="ts">
const KVideoPlayer = defineAsyncComponent(() => import('@/components/KVideoPlayer.client.vue'))
const props = defineProps<{ images: string[], videoUrl?: string, imgTitle?: string }>()
const slides = computed(() => props.videoUrl ? [props.videoUrl, ...props.images] : props.images)
const { preparedImages, prepareImages, onImageLoad } = useSwipeImageLoading(slides)
const swipeRef = ref()
watch(slides, () => {
  KVideoPlayerShow.value = false
  nextTick(() => swipeRef.value?.swipeTo(0, { immediate: true }))
})

const KVideoPlayerShow = ref<boolean>(false)
const handlePlayerClick = async() => {
  KVideoPlayerShow.value = true
}
</script>

<style lang="scss" scoped>
.img-box{
  position: relative;
  height: 0;
  width: 100vw;
  padding-bottom: 100%;
  .img{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.switer-image{
  position: relative;
  .custom-indicator{
    position: absolute;
    right: 15px;
    bottom: 15px;
    border-radius: 25px;
    font-size: 22px;
    padding: 5px 20px;
    color: #f5f5f5;
    background-color: rgba($color: #000000, $alpha: 0.3);
  }
  .img-content{
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .loading-box{
    @include center();
  }
}
</style>
